import React from 'react'
import styled from 'styled-components'

import Container from '../Container'

import badgeIcon from '../../assets/img/BLOK.jpg'

interface PageHeaderProps {
  icon: React.ReactNode
  subtitle?: string
  title?: string
  hasLP?: boolean
}

const PageHeader: React.FC<PageHeaderProps> = ({ icon, subtitle, title, hasLP = true }) => {
  return (
    <Container size="lg">
      <StyledPageHeader>
        <img src={badgeIcon} width="96" />
        <StyledTitle>Bloktopia JOBE #{process.env.REACT_APP_JOBE_NUMBER}</StyledTitle>
        <StyledSubtitle>Join the JOBE to earn rent in BLOK paid monthly</StyledSubtitle>
        <StyledSubtitle>{process.env.REACT_APP_HEADER_TEXT}</StyledSubtitle>
        <StyledSubtitle color="#FFF">On the 1st of every month, the JOBE is paused for rewards to be added which can be claimed from the 2nd onwards</StyledSubtitle>

      </StyledPageHeader>
    </Container>
  )
}

const StyledLink=styled.a`
  margin-top: 10px;
  color: ${(props) => props.theme.color.red[500]};
`

const StyledPageHeader = styled.div`
  background-color: #000;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => props.theme.spacing[6]}px;
  padding-top: ${(props) => props.theme.spacing[6]}px;
  margin: 0 auto;
`

const StyledIcon = styled.div`
  font-size: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  width: 120px;
`

const StyledTitle = styled.h1`
  color: ${(props) => props.theme.color.purple[500]};
  font-size: 45px;
  text-align: center;
  font-weight: 600;
  margin: 0;
  padding: 0;
`

const StyledSubtitle = styled.h3`
  color: #9C28EC;
  font-size: 18px;
  font-weight: 300;
  margin-top: 10px;
  padding: 0;
  text-align: center;
`

const StyledWarning = styled.h3`
  color: ${(props) => props.theme.color.red[600]};
  font-size: 18px;
  font-weight: 300;
  margin-top: 10px;
  padding: 0;
  text-align: center;
`

export default PageHeader
